var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"worker-link-item",attrs:{"to":{name: _vm.nameLink}}},[_vm._v(" "+_vm._s(_vm.titleLink)),_c('b-icon',{staticStyle:{"margin-left":"10px"},attrs:{"icon":_vm.iconName,"pack":"fa","type":"is-primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }